import React, { useCallback, useRef, useEffect, useState } from 'react';
import { FormHandles } from '@unform/core';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import { Link, useHistory } from 'react-router-dom';

import { IconType } from 'react-icons/lib';

import {
  Container,
  SecondaryContainer,
  ContainerWhite,
  GreyContainer,
  Capa,
  ProgramContainer,
  Sponsors,
  Photo,
} from './styles';

import getValidationErrors from '../../utils/getValidationErrors';

import { useAuth } from '../../hooks/Auth';
import { useToast } from '../../hooks/Toast';
import { useModal } from '../../hooks/Modal';

import { usePages } from '../../hooks/Pages';
import { useLanguage } from '../../hooks/Language';
import SlideList from '../DashboardPages/features/SliderComponent';
import ProjectList from '../DashboardPages/features/ProjectList';
import EventList from '../DashboardPages/features/EventsList';
import api from '../../services/api';
import { urlWebsite } from '../../config';
import { Button } from '../../components/Button/styles';
import SliderContainer from '../../components/SliderContainer';
import { FaBrain, FaStar } from 'react-icons/fa';
import Calendar from './modules/Calendar';
import SponsorContainer from '../Sponsors';
interface IMenu {
  title: string;
  target: string;
  targetID: string;
  fluid: number;
  external: number;
  status: number;
}

interface SignInData {
  email: string;
  password: string;
}

interface IPublicData {
  icon: IconType;
  title: string;
  text: string;
}

const Home: React.FC = () => {

  const { setMenu } = usePages();
  const { setAvailableLanguages } = useLanguage();
  const { translate } = useLanguage();
  const lorem = 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.';
  const { addModal, removeModal } = useModal();
  const [slides, setSlides] = useState<Array<JSX.Element>>([]);
  const { user } = useAuth();
  const loadConfig = async () => {
    const config = await api.get('/get_platform');

    if (config.data.slides) {
      const slideJSX: Array<JSX.Element> = [];

      config.data.slides.map(s => {
        slideJSX.push(s.link_url ? <a href={s.link_url}><img src={`${urlWebsite}/${s.url}`} style={{ width: '100%' }} /></a> : <img src={`${urlWebsite}/${s.url}`} style={{ width: '100%' }} />)
      })

      setSlides(slideJSX);



    }

    const menu: Array<IMenu> = [];

    try {
      config?.data?.menu.map((m: IMenu) => {
        m.fluid = parseInt(m.fluid.toString(), 10);
        m.status = parseInt(m.status.toString(), 10);
        m.external = parseInt(m.external.toString(), 10);

        menu.push(m);
      })

      setMenu(menu);

    }
    catch (err) {
      console.log('Error on define Menu');
    }


    setAvailableLanguages(config?.data?.languages || []);


  }

  useEffect(() => {
    loadConfig();
    /*
        addModal({
       key:'popup',
       theme: 'whiteModal2',
       title:' ',
       content: <><div style={{width:'100%', maxWidth:'500px', margin: '0px auto'}}>
         <Link onClick={() => removeModal('popup')} style={{width:'100%', maxWidth:'500px', margin: '0px auto'}} to="/app/sessao-clinica-hospitais-dasa-brasil/login">
           <img src="/apoio/sessao-clinica.png" style={{width:'100%', maxWidth:'500px', margin: '0px auto'}}/>
         </Link>
         </div></>
     }  ) */
  }, [])

  const [news, setNews] = useState([
    { project: 'Global Stroke', title: 'Estudo sobre AVC na américa Latina', date: '2022-01-12 22:00:00', date_formatted: '12 de janeiro, 19h (GMT-3)', description: `<p>${lorem}</p>`, url: '/app/globalstroke', image: '/projects/globalstroke.png' },
    { project: 'Agentes comunitários', title: 'Módulo 4', date: '2022-01-14 21:00:00', date_formatted: '14 de janeiro, 18h (GMT-3)', description: `<p>${lorem}</p>`, url: '/app/agentes-comunitarios', image: '/projects/agentescomunitarios.png' },
    { project: 'Combatendo o AVC', title: 'Módulo 5', date: '2022-01-16 21:00:00', date_formatted: '16 de janeiro, 18h (GMT-3)', description: `<p>${lorem}</p>`, url: '/app/combatendo-o-avc', image: '/projects/combatendooavc.png' },

  ]);

  return (
    <>
      <Capa style={{ margin: '0px', justifyContent: 'center', gap: '30px' }}>
        <div className='p50 ' style={{ justifyContent: 'center', alignItems: 'center', margin: '0px' }}>
          <img src="/apoio/capa.png" style={{ width: '100%', alignSelf: 'flex-start', margin: '0px' }} />

        </div>

        <div style={{ width: '100%', maxWidth: '400px', background: 'none', borderRadius: '15px', padding: '50px 20px', }}>

          <Link to='/app/microbiologia-2022/login'><button className="defaultButton">ACESSAR</button></Link>

          <a href='https://www.ufrgs.br/sbma/xiv-sbma-vi-elama/' target='_BLANK'><button className="defaultButton">INFORMAÇÕES</button></a>

        </div>

      </Capa>

      <SponsorContainer />

    </>
  );
};
export default Home;
